// Based on Mantine 7.9.0 @mantine/hooks/use-media-query

import { useEffect, useRef, useState } from "react";

type MediaQueryCallback = (event: MediaQueryListEvent) => void;

function attachMediaListener(
    query: MediaQueryList,
    callback: MediaQueryCallback,
) {
    try {
        query.addEventListener("change", callback);
        return () => query.removeEventListener("change", callback);
    } catch {
        query.addListener(callback);
        return () => query.removeListener(callback);
    }
}

export default function useMediaQuery(
    query: string,
    onMatch?: MediaQueryCallback,
) {
    const [matches, setMatches] = useState(false);
    const queryRef = useRef<MediaQueryList>();
    const onMatchRef = useRef(onMatch);

    useEffect(() => {
        if ("matchMedia" in window) {
            queryRef.current = window.matchMedia(query);
            setMatches(queryRef.current.matches);
            return attachMediaListener(queryRef.current, (event) => {
                setMatches(event.matches);
                onMatchRef.current?.(event);
            });
        }

        return undefined;
    }, [query]);

    return matches;
}
